import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { connectModal, Modal, Button } from '@gsa/afp-component-library';

const AgencyGInvoiceModal = ({ isOpen, onClose }) => {
  const ReadModal = useMemo(() => () => (
    <Modal
      variant="small"
      onClose={onClose}
      title="This requisition contains a G-Invoicing enabled BOAC."
      className="agency-info-change-modal"
      actions={
        <div>
          <Button variant="primary" onClick={onClose} label="Ok" />
        </div>
      }
    >
      <div>
        The billing AAC supplied requires the use of G-Invoicing. An Order
        Authorization must be approved before GSA will finalize your order.
      </div>
    </Modal>
  ));

  const ConnectedModal = connectModal(ReadModal);

  return <ConnectedModal isOpen={isOpen} onClose={onClose} />;
};

AgencyGInvoiceModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default AgencyGInvoiceModal;
